import React from "react";
import styles from "./Button.module.scss";

export const GoogleButton = ({ onClick }) => (
  <button type="button" className={styles.button} onClick={onClick} />
);
